import React, { useState, useEffect } from "react";
import styles from "./ABMListFondista.module.css";
import DownloadButton from "../DownloadButton/DownloadButton";
import EditABM from "../EditABM/EditABM";
import DownButton from "../DownButton/DownButton";
import CreateABM from "../CreateABM/CreateABM";
import PrintButton from "../PrintButton/PrintButton";
import axios from "axios";
import { TiDelete } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";

const AMBListFondista = ({
  data,
  displayList,
  setTypeDocument,
  setFileId,
  reloadChildData,
}) => {
  const [aMB, setAMB] = useState([]);
  const [documentDeletedId, setDocumentDeletedId] = useState(null);

  useEffect(() => {
    const userId = data.id;
    const apiUrl = `${process.env.REACT_APP_LEALTAD_ABM_OF_DOCUMENT_GET_ALL}?userId=${userId}`;

    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl);
        if (response.status === 204) {
          setAMB([]);
        } else {
          setAMB(response.data);
        }
      } catch (error) {}
    };

    fetchData();
  }, [data, reloadChildData, documentDeletedId]);

  const combinedValues = [
    {
      variable: "ESTATUTO - REFORMA ESTATUTARIA",
    },
    {
      variable: "ULTIMO BALANCE CERTIFICADO",
    },
    {
      variable: "DJ DE PERSONAS JURIDICAS",
    },
    {
      variable: "DJ ORIGEN Y LICITUD DE FONDOS PERSONA JURÍDICA",
    },
    {
      variable: "DJ DE AUTORIDADES VIGENTES",
    },
    {
      variable: "ACTA DE ASAMBLEA DE DESIGNACION DE AUTORIDADES VIGENTES",
    },
    {
      variable: "ACTA DE ORGANO DIRECTIVO DE DISTRIBUCION DE CARGOS",
    },
    {
      variable: "DNI DE AUTORIDADES VIGENTES",
    },
    {
      variable: "CONSTANCIA INSCRIPCION UIF (DE CORRESPONDER)",
    },
    {
      variable: "DJ PEP AUTORIDADES (134/2018)",
    },
    {
      variable:
        "DJ CUMPLIMIENTO NORMATIVAS UIF - OFICIAL DE CUMPLIMIENTO (DE CORRESPONDER)",
    },
    {
      variable: "CONSTANCIA INSCRIPCION UIF OFICIAL DE CUMPLIMIENTO",
    },
    {
      variable: "ACTA DE ASAMBLEA DESIGNACION OFICIAL DE CUMPLIMIENTO",
    },
    {
      variable:
        "ACTA DE ORGANO DIRECTIVO APROBACION MANUAL DE PROCEDIMIENTOS PLA/FT",
    },
    {
      variable: "COPIA DEL MANUAL DE PROCEDIMIENTOS PLA/FT",
    },
  ].map((item) => {
    // Resto del mapeo si no es un 404
    const matchingDocument = aMB.find(
      (doc) => doc.typeDocument === item.variable
    );

    if (matchingDocument) {
      return {
        id: matchingDocument.id,
        file: "Yes",
        estado: <AiFillCheckCircle style={{ color: "green" }} />,
        variable: item.variable,
        valorObtenido: matchingDocument.description,
        riesgoObtenido: `${
          matchingDocument.expiresAt === "1"
            ? "1 Mes"
            : matchingDocument.expiresAt + " Meses"
        }`,
      };
    } else {
      return {
        estado: <TiDelete style={{ color: "red" }} />,
        file: "No",
        variable: item.variable,
        valorObtenido: "-",
        riesgoObtenido: "-",
      };
    }
  });

  const OpenForm = (viewOrNot) => {
    displayList(viewOrNot);
  };

  return (
    <div className={styles.bodyMDRLealtad}>
      <>
        <table className={styles.tableMDRLealtad}>
          <thead>
            <tr>
              <th>Estado</th>
              <th>Tipo de archivo</th>
              <th>Descripcion</th>
              <th>Fecha de vencimiento</th>
              <th>Alta</th>
              <th>Baja</th>
              <th>Modificacion</th>
              <th>Descargar</th>
              <th>Imprimir</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td>{item.estado}</td>
                <td>{item.variable}</td>
                <td>{item.valorObtenido}</td>
                <td className={styles.numberSquareMDRLealtad}>
                  <div className={styles.numberContainerMDRLealtad}>
                    <p>{item.riesgoObtenido}</p>
                  </div>
                </td>
                <td>
                  {item.file === "No" ? (
                    <CreateABM
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownButton
                      id={item.id}
                      onDocumentDeleted={setDocumentDeletedId}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <EditABM
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      id={item.id}
                      setFileId={setFileId}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownloadButton id={item.id} typeDocument={item.variable} />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <PrintButton id={item.id} />
                  ) : (
                    <div></div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    </div>
  );
};

export default AMBListFondista;
